import * as ko from "knockout";
import {IMessageData} from "../../../../index";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {ObjectTypeId} from "../../../../constants";
import {createErrorMessage} from "../../../../util/misc";
import {ITypeComponentParams, TState} from "./index";
import {DynamicProperties} from "./DynamicProperties";
import {TComponentName} from "../../../../constants/ComponentRegistry";
import {REQUEST_MESSAGE} from "../../../../constants/Language";
import mutableHtml from './mutable.html?raw';

export let template = mutableHtml;

interface IParams {
    dynamicProperties: DynamicProperties
}

export class viewModel {
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly dynamicProperties: DynamicProperties;

    constructor(private params: IParams) {
        this.dynamicProperties = params.dynamicProperties;
        this.kosub.subscribe(this.dynamicProperties.state, this.onDynamicPropertiesState.bind(this));
        this.onDynamicPropertiesState(this.dynamicProperties.state());
    }

    private onDynamicPropertiesState(state: TState) {
        switch (state) {
            case "waiting":
                this.messageData(null);
                this.isReady(false);
                break;
            case "loading":
                this.messageData({message: REQUEST_MESSAGE});
                this.isReady(false);
                break;
            case "ready":
                this.messageData(null);
                this.isReady(true);
                break;
            case "error":
                this.messageData(createErrorMessage(this.dynamicProperties.reason() ?? ''));
                this.isReady(false);
                break;

        }
    }

    private getTypeComponentParams(): ITypeComponentParams {
        const prefix = 'component/form/template/properties/type/';
        let name = prefix + this.dynamicProperties.getName('lower');
        if (!ko.components.isRegistered(name)) {
            switch (this.dynamicProperties.syncfield()?.objecttypeid) {
                case ObjectTypeId.Function:
                    name = prefix + 'function';
                    break;
                default:
                    name = prefix + 'default';
                    break;
            }
        }
        return {
            name: name as TComponentName,
            params: {
                dynamicProperties: this.dynamicProperties,
            }
        }
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
